import { jsxs, jsx } from "react/jsx-runtime";
import { IconSvgPaths16 } from "@blueprintjs/icons";
import { useClassNameFactory } from "@contember/react-utils";
import { memo, forwardRef, useMemo } from "react";
import * as index from "./contemberIcons/index.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { toViewClass } from "../../utils/toViewClass.js";
const renderSvgPaths = (pathStrings) => {
  if (!pathStrings || !pathStrings.length) {
    return null;
  }
  return pathStrings.map((d, i) => /* @__PURE__ */ jsx("path", { d, fillRule: "evenodd" }, i));
};
const Icon = memo(forwardRef(function Icon2(props, ref) {
  const componentClassName = useClassNameFactory("icon");
  const svgClassName = props.blueprintIcon ? componentClassName("blueprintSvg") : componentClassName("contemberSvg");
  const icon = useMemo(() => {
    if (props.customIcon && !Array.isArray(props.customIcon)) {
      return props.customIcon;
    }
    let pathStrings;
    if (props.blueprintIcon) {
      pathStrings = IconSvgPaths16[props.blueprintIcon];
    } else if (props.contemberIcon) {
      pathStrings = index[props.contemberIcon];
    } else {
      return null;
    }
    const svgPaths = renderSvgPaths(pathStrings);
    return /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 16 16", className: svgClassName, children: [
      props.title && /* @__PURE__ */ jsx("desc", { children: props.title }),
      svgPaths
    ] });
  }, [props.blueprintIcon, props.contemberIcon, props.customIcon, props.title, svgClassName]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: componentClassName(null, [
        toEnumViewClass(props.size),
        toViewClass("alignWithLowercase", props.alignWithLowercase)
      ]),
      style: props.style,
      ref,
      onClick: props.onClick,
      children: icon
    }
  );
}));
export {
  Icon
};
//# sourceMappingURL=Icon.js.map
